const part = [
    {
        path: 'personalnotice-list',
        name: 'personalnotice-list',
        meta: {
            icon: 'md-people',
            title: '个人通知管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/personalnotice-managment/personal-notice')
    }
];

export default part;